import { render, staticRenderFns } from "./PlaceholderMessage.vue?vue&type=template&id=8c4b961e&scoped=true&"
import script from "./PlaceholderMessage.vue?vue&type=script&lang=js&"
export * from "./PlaceholderMessage.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderMessage.vue?vue&type=style&index=0&id=8c4b961e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4b961e",
  null
  
)

export default component.exports